import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from "../../App";
import 'bootstrap/dist/css/bootstrap.min.css';
import { MdCall, MdWhatsapp, MdEmail, MdShield, MdNotificationsActive, MdTimer, MdHeadset, MdChevronRight } from "react-icons/md";
import vat from '../../assets/vat.png';
import sdl from '../../assets/sdl.png';
import paye from '../../assets/paye.png';
import nssf from '../../assets/nssf.jpg';
import wcf from '../../assets/wcf.png';
import banner1 from '../../assets/banner1.png';
import receipt from '../../assets/receipt.png';
import filing from '../../assets/filing.png';
import resolution from '../../assets/resolution.png';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaWhatsapp } from 'react-icons/fa';

export default function ServicesBanner1() {
  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);

  const appContext = useContext(AppContext);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {

  }, []);

  const features = [
    { title: 'One partner', detail: 'All filings, one desk', icon: MdShield, accent: '#0b1220' },
    { title: 'Live alerts', detail: 'Deadline tracker + reminders', icon: MdNotificationsActive, accent: '#1d4ed8' },
    { title: 'Always audit ready', detail: 'Clean, reviewed records', icon: MdTimer, accent: '#14b8a6' },
    { title: 'Direct line', detail: 'Call · WhatsApp · Email', icon: MdHeadset, accent: '#f97316' },
  ];

  const heroHighlights = [
    { value: '1,200+', label: 'Returns tracked monthly' },
    { value: '60+', label: 'Local & regional clients' },
    { value: '99.8%', label: 'On-time submissions' },
  ];

  const coreFilings = [
    { id: 'VAT', title: 'VAT Returns', desc: 'Prep, review, submit', image: vat, emoji: '🧾' },
    { id: 'PAYE', title: 'PAYE', desc: 'Pay As you Earn', image: paye, emoji: '👥' },
    { id: 'SDL', title: 'SDL', desc: 'Skills Development Levy', image: sdl, emoji: '💡' },
    { id: 'NSSF', title: 'NSSF', desc: 'National Social Security Fund', image: nssf, emoji: '🔒' },
    { id: 'WCF', title: 'WCF', desc: 'Workers compensation Fund', image: wcf, emoji: '🛡️' },
  ];

  const serviceClusters = [
    
    {
      title: 'TRA Filing Services',
      tag: 'Compliance',
      desc: 'VAT · PAYE · SDL · NSSF · WCF',
      accent: 'secondary',
      items: [
        { label: 'Statement of Estimates', value: '350-500k' },
        { label: 'Annual Return of Income', value: '500-800k' },
        { label: 'Adjustments & revisions', value: '250-400k' },
      ],
    },
    {
      title: 'Business Setup',
      tag: 'Launch',
      desc: 'Brela + TRA onboarding',
      accent: 'primary',
      items: [
        { label: 'Company registration', value: '800k' },
        { label: 'TRA activation', value: '100k' },
        { label: 'Business name', value: '70k' },
        { label: 'Tax Clearance Request', value: '30k' },
      ],
    },
    {
      title: 'Unfiled Returns',
      tag: 'Resolution',
      desc: 'Penalty relief + remission',
      accent: 'tertiary',
      items: [
        { label: '≤ 2 years', value: 'From 500k TZS' },
        { label: '2-4 years', value: 'From 800k TZS' },
        { label: '> 4 years', value: 'From 1.2M TZS' },
      ],
    },
  ];

  const specialCases = [
    {
      title: 'Receipt correction',
      desc: 'Fix or cancel mistaken EFD receipts',
      image: receipt,
      target: 'RECEIPT',
      subItem: 'RECEIPT'
    },
    {
      title: 'Return adjustment',
      desc: 'Edit filings on TRA portal',
      image: filing,
      target: 'FILING',
      subItem: 'FILING'
    },
    {
      title: 'Penalty relief',
      desc: 'Unfiled returns + remission support',
      image: resolution,
      target: 'RESOLUTION',
      subItem: 'RESOLUTION'
    },
  ];

  const faqs = [
    { q: 'Are you tax consultants?', a: 'We manage filings via trained specialists reviewed by CPA(T).' },
    { q: 'Who files the returns?', a: 'We submit VAT, PAYE, SDL, NSSF, WCF and related TRA returns on your behalf.' },
    { q: 'What data do you need?', a: 'Share payroll, sales, purchases, employees, and registration numbers.' },
    { q: 'Can I pick single services?', a: 'Yes: choose the filings that match what you need.' },
    { q: 'How fast do you reply?', a: 'We answer in minutes by call, WhatsApp, or email.' },
    { q: 'How do I get started?', a: 'Contact us and we will send the onboarding checklist right away.' },
  ];

  const accentPalette = {
    primary: 'var(--brand-primary)',
    secondary: 'var(--brand-secondary)',
    tertiary: 'var(--brand-accent-2, #0f766e)',
  };

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const FeatureBlock = ({ title, detail, icon: Icon, accent, aosDelay = 0 }) => (
    <div
      className="feature-block"
      data-aos="fade-up"
      data-aos-delay={aosDelay}
      style={{
        borderColor: accent,
        boxShadow: `0 2px 3px #3a3737`,
      }}
    >
      <span className="feature-block__icon flex-shrink-0" style={{ color: accent, background: `${accent}20` }}>
        {Icon && <Icon size={24} />}
      </span>
      <div>
        <p className="feature-block__title">{title}</p>
        <p className="feature-block__detail">{detail}</p>
      </div>
    </div>
  );

  const FilingCard = ({ id, title, desc, image, emoji }) => (
    <button
      type="button"
      className="core-card"
      data-aos="fade-up"
      onClick={() => appContext.navTo({ item: 'view', subItem: id })}
    >
      <div className="core-card__emoji">{emoji}</div>
      <div className="core-card__title-group">
        <p className="core-card__subtitle">{desc}</p>
        <h3>{title}</h3>
      </div>
      <div className="core-card__media">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="core-card__cta">
        <span>Open service</span>
        <MdChevronRight size={20} />
      </div>
    </button>
  );

  const ServiceCluster = ({ title, desc, tag, items, accent, aosDelay = 0 }) => (
    <article
      className="cluster-card"
      data-aos="fade-up"
      data-aos-delay={aosDelay}
      style={{ borderColor: accentPalette[accent] }}
    >
      <header className="cluster-card__header bg-primary p-2 rounded">
        <h3 className="font-bold text-light mb-1">{title}</h3>
        <p className="text-secondary font-semi-bold">{desc}</p>
      </header>
      <div className="cluster-card__content">
        {items.map((item) => (
          <div key={item.label} className="cluster-card__row">
            <span style={{background:"rgba(0,0,0,.05)", width:"50%"}} className='p-1 rounded h-100'>{item.label}</span>
            <span style={{background:"rgba(0,0,0,.25)", width:"40%", display:"grid", placeItems:"center"}} className='p-1 rounded text-dark font-bold h-100'>{item.value}</span>
          </div>
        ))}
      </div>
    </article>
  );

  const SpecialCaseCard = ({ title, desc, image, subItem, aosDelay = 0 }) => (
    <div className="special-card" data-aos="fade-up" data-aos-delay={aosDelay} style={{cursor:"pointer"}}>
      <div className="special-card__media">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="special-card__body" onClick={()=>appContext.navTo({item:'view', subItem: subItem})}>
        <h4 className="font-semi-bold special_title">{title}</h4>
        <p>{desc}</p>
        <div className="text-end">
          <MdChevronRight size={24} />
        </div>
      </div>
    </div>
  );

  const FaqCard = ({ q, a, index, isOpen }) => (
    <div className={`faq-card ${isOpen ? 'faq-card--open' : ''}`}>
      <button
        type="button"
        className="faq-card__question font-semi-bold"
        onClick={() => toggleFaq(index)}
        aria-expanded={isOpen}
      >
        <span>{q}</span>
        <MdChevronRight className={`faq-card__chevron ${isOpen ? 'is-open' : ''}`} />
      </button>
      <div className={`faq-card__answer ${isOpen ? 'is-visible' : ''}`} aria-hidden={!isOpen}>
        <p className='text-dark'>{a}</p>
      </div>
    </div>
  );

  return (
    <div
      className="services-banner services-banner--home pb-5"
      style={{
        '--brand-primary': '#0b1220',
        '--brand-secondary': '#1d4ed8',
        '--brand-accent-2': '#14b8a6',
        '--brand-surface': '#f4f6fb',
        '--brand-muted': '#94a3b8',
      }}
    >

      <section className="hero-panel hero-panel--full mShadow1">
        <div className="hero-content mt-5" data-aos="fade-right" >
          <h1 className='font-bold'>Werenium<br/>Tax Compliance</h1>
          <div className="hero-subline">
            <span className='hero-subline__badge font-semi-bold'>VAT · PAYE · SDL · NSSF · WCF</span>
            <p className="hero-subline__tagline">Professional compliance, modern workflow, and transparent reporting for teams that prefer clarity over chaos.</p>
          </div>
          <div className="hero-actions">
            <a href="tel:+255758779913" className="btn btn-secondary btn-lg" data-aos="zoom-in">
              Call now
            </a>
            <a href="https://wa.me/255758779913" target="_blank" rel="noreferrer" className="btn btn-outline-light btn-lg" data-aos="zoom-in">
              <FaWhatsapp size={24} /> WhatsApp
            </a>
          </div>
          
        </div>
        <div className="hero-visual" data-aos="fade-right">
          <img src={banner1} alt="Compliance team" loading="lazy" />
        </div>
      </section>
      
      <section className="service-cluster-section p-2 p-md-5 mt-5">
        <div className="section-heading">
          <h2 className="font-bold text-secondary">Tax Compliance Services</h2>
        </div>
        <div className="cluster-grid">
          {serviceClusters.map((cluster, index) => (
            <ServiceCluster key={cluster.title} aosDelay={index * 100} {...cluster} />
          ))}
        </div>
      </section>

      <section className="contact-cta">
        <div className="contact-cta__text">
          <h3 className="font-bold text-secondary">Need Filing help now?</h3>
          <p className="text-muted font-semi-bold">We answer within moments via call, WhatsApp, or email.</p>
        </div>
        <div className="contact-actions">
          <a href="tel:+255758779913" className="btn btn-primary btn-rounded">
            <MdCall size={20} /> Call
          </a>
          <a href="https://wa.me/255758779913" target="_blank" rel="noreferrer" className="btn btn-success btn-rounded">
            <MdWhatsapp size={20} /> WhatsApp
          </a>
          <a href="mailto:efiling@werenium.com" className="btn btn-outline-dark btn-rounded">
            <MdEmail size={20} /> Email
          </a>
        </div>
      </section>

      <section className="core-section" id="services">
        <div className="section-heading text-center mt-3">
          <h2 className="text-primary font-bold">Core filings</h2>
          <p className="text-muted font-semi-bold">VAT · PAYE · SDL · NSSF · WCF</p>
        </div>
        <div className="core-grid">
          {coreFilings.map((item) => (
            <FilingCard key={item.id} {...item} />
          ))}
        </div>
      </section>

      <section className="special-section mt-5">
        <div className="section-heading text-center">
          <h2 className="text-primary font-bold">Related Filings</h2>
        </div>
        <div className="special-grid">
          {specialCases.map((item, index) => (
            <SpecialCaseCard key={item.title} aosDelay={index * 120} {...item} />
          ))}
        </div>
      </section>

      <section className="contact-cta">
        <div className="contact-cta__text">
          <h3 className="font-bold text-secondary">Need Filing help now?</h3>
          <p className="muted small">We answer within moments via call, WhatsApp, or email.</p>
        </div>
        <div className="contact-actions">
          <a href="tel:+255758779913" className="btn btn-primary btn-lg">
            <MdCall size={20} /> Call
          </a>
          <a href="https://wa.me/255758779913" target="_blank" rel="noreferrer" className="btn btn-success btn-lg">
            <MdWhatsapp size={20} /> WhatsApp
          </a>
          <a href="mailto:efiling@werenium.com" className="btn btn-outline-dark btn-lg">
            <MdEmail size={20} /> Email
          </a>
        </div>
      </section>

      

      

      <section className="faq-section">
        <div className="section-heading">
          <h2>FAQS</h2>
        </div>
        <div className="faq-grid">
          {faqs.map((item, index) => (
            <FaqCard
              key={item.q}
              index={index}
              isOpen={openFaq === index}
              {...item}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
